<div class="app-wrapper container-fluid m-h-100-vh px-0" [ngClass]="{'mobile': isMobileVersion}">
  <p-toast position="top-right" (onClose)="onToastClose($event)"></p-toast>
  <ng-progress></ng-progress>
  <router-outlet></router-outlet>
</div>